import { baseType, colors, weights } from '@components/theme/styles/index';
import { Chip, styled } from '@mui/material';
import { rem } from 'polished';

export const ToLine = styled('div')(
  ({ theme }) =>
    ({
      display: 'flex',
      alignItems: 'center',
      gap: rem(10),
      padding: `${rem(10)} ${rem(16)}`,
      background: 'none',
      border: 'none',
      [theme.breakpoints.up('sm')]: {
        padding: `${rem(10)} ${rem(50)}`,
      },
      color: colors.grayDark3,
    }) as any,
);

export const ToLineLabel = styled('p')({
  fontWeight: weights.medium,
  fontFamily: baseType,
  fontSize: rem(14),
  color: colors.grayDark2,
  userSelect: 'none',
});

export const ToLineTags = styled('div')({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: rem(6),
});

export const StyledChip = styled(Chip)({
  '&.MuiChip-colorContact': {
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: colors.grayLight2,
    },
  },
  '& .MuiChip-icon': {
    color: colors.grayDark1,
  },
  '& .MuiChip-label': {
    '&:hover': {
      '> a': {
        opacity: 1,
      },
    },
  },
});

export const StyledLink = styled('span')({
  color: colors.blueDark3,
  transition: 'color 0.3s ease',
  opacity: 1,
  '&:hover': {
    color: colors.blueDark1,
  },
});

export const StyledName = styled('span')({
  color: colors.grayDark3,
  cursor: 'pointer',
  '&:hover': {
    color: colors.grayDark3,
    textDecoration: 'underline',
  },
});

export const StyledBox = styled('div')({
  borderRadius: rem(5),
  border: `1px solid ${colors.grayLight1}`,
  background: colors.white,
  boxShadow: `0px 4px 6px 0px rgba(0, 0, 0, 0.15)`,
  padding: `${rem(8)}`,
  color: colors.grayDark3,
  '>p': {
    width: rem(212),
    height: rem(34),
    padding: `${rem(6)} ${rem(10)}`,
  },
});
